<div
  class="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white border-t-transparent"
  aria-hidden="true"
></div>
